import { auth } from 'utils'
import Vue from 'vue'
import store from 'vx/store'
import permissions from './permissions'

export default (to, from, next) => {
  Vue.prototype.$user = {}
  if (to.meta.unauthenticated !== true) {
    auth.attemptViaToken(false)
      .then(() => {
        Vue.prototype.$user = store.getters['authentication/authorized']
        Vue.prototype.$clientConfig = store.getters['clientConfig/client_config']
        if (store.getters['authentication/authorized']) {
          permissions(to, from, next, store.getters['authentication/authorized'])
        }
      })
      .catch((error) => {
        // TODO: Log this error somewhere as it might be important as to why authentication failed.
        console.warn(error)

        auth.redirectOnTokenExpired(to)
      })
  } else {
    next()
  }
}
